module.exports = __webpack_public_path__ + "img/U_talk.9e5f34ca.gif";